<template>
  <el-dialog :visible.sync="visible">
    <h3 class="title">《检验网隐私政策》</h3>
    <p class="title">总则</p>
    <p>我们非常重视您的个人信息保护与个人隐私，也理解您可能关心您的个人信息是如何被使用和共享的，因此我们制订了本隐私政策，阐述了我们如何收集、使用、披露、共享以及储存您的个人信息。</p>
    <p>请您仔细阅读本隐私政策。通过使用我们的产品和/或服务，您同意：您已满十八周岁且已完全理解并接受本隐私政策的全部条款和内容。如果您不同意本隐私政策，您可以不使用我们的产品和/或服务。</p>
    <br/>
    <p class="title">隐私信息收集与保护</p>
    <p>1. 在您注册 检验网会员时、使用 检验网产品或服务、访问 检验网网页， 检验网会收集你的个人身份识别资料。 检验网也会收集来自商业伙伴的身份识别资料。只要你在 检验网成功注册并登录服务器，我们将可以识别你。</p>
    <p>2. 您可以随时修改您的个人信息和密码，请谨慎保护您的密码，防止密码被盗，个人信息外泄。</p>
    <p>3. 检验网会将这些资料用于：</p>
    <p>（1）网站用户的信息统计工作；</p>
    <p>（2）优化为您提供的服务及体验工作；</p>
    <p>（3）您所同意的其他用途。</p>
    <p>4. 检验网非常重视对用户隐私权的保护，检验网在此郑重承诺：不会在未获得用户许可的情况下擅自将用户的个人资料信息出租或出售给任何第三方。除以下免责条款外：</p>
    <p>（1）您同意公开你的个人资料，享受为您提供的产品和服务；</p>
    <p>（2）检验网需要听从法庭传票、法律命令或遵循法律程序；</p>
    <p>（3）检验网发现您违反了 检验网服务条款或 检验网其它使用规定。</p>
    <p>5. 出现下列情况时本网站不承担任何责任</p>
    <p>（1）您同意让第三方共享资料；</p>
    <p> （2）您虽未同意，但由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露。</p>
    <p> （3）只有透露您的个人资料，才能提供您所要求的产品和服务；</p>
    <p> （4）任何由于不可抗力、黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被篡改等。</p>
    <p> （5）由于与 检验网链接的其它网站所造成之个人资料或相关内容泄露及由此而导致的任何法律争议和后果。</p>
    <p> （6）我们发现您违反了 检验网服务条款或其他产品及服务的使用规定。</p>
    <br/>
    <p class="title">附则</p>
    <P>我们只会在达成本政策所述目的所需的期限内保留您的个人信息，超出必要期限后，我们会对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</P>
    <p>对免责声明的解释、修改及更新权均属于 检验网所有。</p>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  import { getCookie } from "../util/util"

  export default {
    name: "privacy-detail",
    data() {
      return {
        visible: false,
      }
    },
    methods: {
      init () {
        this.visible = true
      }
    }
  }
</script>

<style scoped>
  /deep/ .el-dialog__body{
    padding: 0 20px 30px 20px;
  }
  h3.title{
    text-align: center;
    padding: 10px 0 20px 0;
  }
  .title{
    font-size: 17px;
    font-weight: bold;

  }
  p{
    line-height: 30px;
    text-indent:2em
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    /deep/ .el-dialog {
      width: 98%!important;
    }

    /deep/ .el-dialog__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/privacy-detail.vue